// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.budgetContainer {
    .budgetElement {
        width: 83% !important;
        box-shadow: 0px 0px 5px 1px #E2E6EA;
        border-radius: 16px !important;
        overflow: hidden;
        background-color: white;
        padding: 50px 100px !important;

        label {
            font-size: 16px;
            font-weight: 500;
        }


        .elements {
            margin: 15px 0px;

            .elementsPart1 {
                width: 30%;
            }

            .elementsPart2 {
                width: 70%;
            }
        }


        textarea,
        select,
        input {
            width: 100%;
            border: 1px solid #505050;
            padding: 5px 10px;
            font-size: 16px;
            font-weight: 400;
            border-radius: 3px;
        }

        select {
            font-size: 14px !important;
            font-weight: 500 !important;
            color: #817f7f;
        }

        select:focus {
            color: black;
        }

        textarea {
            height: 12vh;
        }

        ::placeholder {
            color: #817f7f;
        }
    }

    .tableContainer {
        width: 100%;

        table {
            width: 100%;
            border: 1px solid #0094DE;


            tr,
            th,
            td {
                padding: 10px;
            }

            th,
            td {
                border: 1px solid #000000;
                font-size: 14px;

            }

            thead {
                tr {
                    background-color: #0094DE;
                    color: white;

                    th {
                        font-weight: 500 !important;
                    }
                }
            }

            tbody {
                tr {
                    td {
                        border: 1px solid #000000 !important;
                        font-weight: 400 !important;
                    }

                }
            }

        }
    }
}



.financeContainer {
    .budgetElement {
        width: 83% !important;
        box-shadow: 0px 0px 5px 1px #E2E6EA;
        border-radius: 16px !important;
        padding: 50px 20px;
        overflow: hidden;
        background-color: white;
        display: flex;
        justify-content: center;
        align-items: center;

        label {
            font-size: 16px;
            font-weight: 500;
        }


        .elements {
            margin: 15px 0px;
        }


        textarea,
        select,
        input {
            width: 100%;
            border: 1px solid #505050;
            padding: 5px 10px;
            font-size: 16px;
            font-weight: 400;
            border-radius: 3px;
        }

        select {
            font-size: 14px !important;
            font-weight: 500 !important;
            color: #817f7f;
        }

        select:focus {
            color: black;
        }

        textarea {
            height: 12vh;
        }

        ::placeholder {
            color: #817f7f;
        }


        .excelContainer {
            background-color: #CCEAF7;
            border-radius: 12px;
            width: 95%;
            padding: 50px 40px;
            border: 1px solid #707EBF;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    .tableContainer {
        width: 100%;

        table {
            width: 100%;
            border: 1px solid #0094DE;


            tr,
            th,
            td {

                padding: 10px;
            }

            th,
            td {
                border: 1px solid #000000;
                font-size: 12px;

            }

            thead {
                tr {
                    background-color: #0094DE;
                    color: white;

                    th {
                        font-weight: 500 !important;
                    }
                }
            }

            tbody {
                tr {
                    td {
                        border: 1px solid #000000 !important;
                        font-weight: 400 !important;
                    }

                }
            }

        }
    }
}


.tableDesign {
    border: 1px solid #98BDED;

    table {
        width: 100%;
        border-collapse: collapse;
        /* border: 1px solid #AFD1F6 !important; */

        thead {
            tr {
                color: 'white';
                height: '3.5rem';
                /* border: 1px solid #AFD1F6 !important; */

                th {
                    border: 1px solid #AFD1F6 !important;
                }
            }
        }

        tbody {
            tr {
                color: 'white';
                height: '3.5rem';
                border: 1px solid #AFD1F6 !important;

                td {
                    border: 1px solid #AFD1F6 !important;
                }
            }
        }


    }
}`, "",{"version":3,"sources":["webpack://./src/Components/admin/pages/BudgetManagement/BudgetEstimation/BudgetEstimation.css"],"names":[],"mappings":"AAAA;IACI;QACI,qBAAqB;QACrB,mCAAmC;QACnC,8BAA8B;QAC9B,gBAAgB;QAChB,uBAAuB;QACvB,8BAA8B;;QAE9B;YACI,eAAe;YACf,gBAAgB;QACpB;;;QAGA;YACI,gBAAgB;;YAEhB;gBACI,UAAU;YACd;;YAEA;gBACI,UAAU;YACd;QACJ;;;QAGA;;;YAGI,WAAW;YACX,yBAAyB;YACzB,iBAAiB;YACjB,eAAe;YACf,gBAAgB;YAChB,kBAAkB;QACtB;;QAEA;YACI,0BAA0B;YAC1B,2BAA2B;YAC3B,cAAc;QAClB;;QAEA;YACI,YAAY;QAChB;;QAEA;YACI,YAAY;QAChB;;QAEA;YACI,cAAc;QAClB;IACJ;;IAEA;QACI,WAAW;;QAEX;YACI,WAAW;YACX,yBAAyB;;;YAGzB;;;gBAGI,aAAa;YACjB;;YAEA;;gBAEI,yBAAyB;gBACzB,eAAe;;YAEnB;;YAEA;gBACI;oBACI,yBAAyB;oBACzB,YAAY;;oBAEZ;wBACI,2BAA2B;oBAC/B;gBACJ;YACJ;;YAEA;gBACI;oBACI;wBACI,oCAAoC;wBACpC,2BAA2B;oBAC/B;;gBAEJ;YACJ;;QAEJ;IACJ;AACJ;;;;AAIA;IACI;QACI,qBAAqB;QACrB,mCAAmC;QACnC,8BAA8B;QAC9B,kBAAkB;QAClB,gBAAgB;QAChB,uBAAuB;QACvB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;;QAEnB;YACI,eAAe;YACf,gBAAgB;QACpB;;;QAGA;YACI,gBAAgB;QACpB;;;QAGA;;;YAGI,WAAW;YACX,yBAAyB;YACzB,iBAAiB;YACjB,eAAe;YACf,gBAAgB;YAChB,kBAAkB;QACtB;;QAEA;YACI,0BAA0B;YAC1B,2BAA2B;YAC3B,cAAc;QAClB;;QAEA;YACI,YAAY;QAChB;;QAEA;YACI,YAAY;QAChB;;QAEA;YACI,cAAc;QAClB;;;QAGA;YACI,yBAAyB;YACzB,mBAAmB;YACnB,UAAU;YACV,kBAAkB;YAClB,yBAAyB;YACzB,aAAa;YACb,uBAAuB;YACvB,mBAAmB;QACvB;IACJ;;IAEA;QACI,WAAW;;QAEX;YACI,WAAW;YACX,yBAAyB;;;YAGzB;;;;gBAII,aAAa;YACjB;;YAEA;;gBAEI,yBAAyB;gBACzB,eAAe;;YAEnB;;YAEA;gBACI;oBACI,yBAAyB;oBACzB,YAAY;;oBAEZ;wBACI,2BAA2B;oBAC/B;gBACJ;YACJ;;YAEA;gBACI;oBACI;wBACI,oCAAoC;wBACpC,2BAA2B;oBAC/B;;gBAEJ;YACJ;;QAEJ;IACJ;AACJ;;;AAGA;IACI,yBAAyB;;IAEzB;QACI,WAAW;QACX,yBAAyB;QACzB,0CAA0C;;QAE1C;YACI;gBACI,cAAc;gBACd,gBAAgB;gBAChB,0CAA0C;;gBAE1C;oBACI,oCAAoC;gBACxC;YACJ;QACJ;;QAEA;YACI;gBACI,cAAc;gBACd,gBAAgB;gBAChB,oCAAoC;;gBAEpC;oBACI,oCAAoC;gBACxC;YACJ;QACJ;;;IAGJ;AACJ","sourcesContent":[".budgetContainer {\r\n    .budgetElement {\r\n        width: 83% !important;\r\n        box-shadow: 0px 0px 5px 1px #E2E6EA;\r\n        border-radius: 16px !important;\r\n        overflow: hidden;\r\n        background-color: white;\r\n        padding: 50px 100px !important;\r\n\r\n        label {\r\n            font-size: 16px;\r\n            font-weight: 500;\r\n        }\r\n\r\n\r\n        .elements {\r\n            margin: 15px 0px;\r\n\r\n            .elementsPart1 {\r\n                width: 30%;\r\n            }\r\n\r\n            .elementsPart2 {\r\n                width: 70%;\r\n            }\r\n        }\r\n\r\n\r\n        textarea,\r\n        select,\r\n        input {\r\n            width: 100%;\r\n            border: 1px solid #505050;\r\n            padding: 5px 10px;\r\n            font-size: 16px;\r\n            font-weight: 400;\r\n            border-radius: 3px;\r\n        }\r\n\r\n        select {\r\n            font-size: 14px !important;\r\n            font-weight: 500 !important;\r\n            color: #817f7f;\r\n        }\r\n\r\n        select:focus {\r\n            color: black;\r\n        }\r\n\r\n        textarea {\r\n            height: 12vh;\r\n        }\r\n\r\n        ::placeholder {\r\n            color: #817f7f;\r\n        }\r\n    }\r\n\r\n    .tableContainer {\r\n        width: 100%;\r\n\r\n        table {\r\n            width: 100%;\r\n            border: 1px solid #0094DE;\r\n\r\n\r\n            tr,\r\n            th,\r\n            td {\r\n                padding: 10px;\r\n            }\r\n\r\n            th,\r\n            td {\r\n                border: 1px solid #000000;\r\n                font-size: 14px;\r\n\r\n            }\r\n\r\n            thead {\r\n                tr {\r\n                    background-color: #0094DE;\r\n                    color: white;\r\n\r\n                    th {\r\n                        font-weight: 500 !important;\r\n                    }\r\n                }\r\n            }\r\n\r\n            tbody {\r\n                tr {\r\n                    td {\r\n                        border: 1px solid #000000 !important;\r\n                        font-weight: 400 !important;\r\n                    }\r\n\r\n                }\r\n            }\r\n\r\n        }\r\n    }\r\n}\r\n\r\n\r\n\r\n.financeContainer {\r\n    .budgetElement {\r\n        width: 83% !important;\r\n        box-shadow: 0px 0px 5px 1px #E2E6EA;\r\n        border-radius: 16px !important;\r\n        padding: 50px 20px;\r\n        overflow: hidden;\r\n        background-color: white;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n\r\n        label {\r\n            font-size: 16px;\r\n            font-weight: 500;\r\n        }\r\n\r\n\r\n        .elements {\r\n            margin: 15px 0px;\r\n        }\r\n\r\n\r\n        textarea,\r\n        select,\r\n        input {\r\n            width: 100%;\r\n            border: 1px solid #505050;\r\n            padding: 5px 10px;\r\n            font-size: 16px;\r\n            font-weight: 400;\r\n            border-radius: 3px;\r\n        }\r\n\r\n        select {\r\n            font-size: 14px !important;\r\n            font-weight: 500 !important;\r\n            color: #817f7f;\r\n        }\r\n\r\n        select:focus {\r\n            color: black;\r\n        }\r\n\r\n        textarea {\r\n            height: 12vh;\r\n        }\r\n\r\n        ::placeholder {\r\n            color: #817f7f;\r\n        }\r\n\r\n\r\n        .excelContainer {\r\n            background-color: #CCEAF7;\r\n            border-radius: 12px;\r\n            width: 95%;\r\n            padding: 50px 40px;\r\n            border: 1px solid #707EBF;\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n        }\r\n    }\r\n\r\n    .tableContainer {\r\n        width: 100%;\r\n\r\n        table {\r\n            width: 100%;\r\n            border: 1px solid #0094DE;\r\n\r\n\r\n            tr,\r\n            th,\r\n            td {\r\n\r\n                padding: 10px;\r\n            }\r\n\r\n            th,\r\n            td {\r\n                border: 1px solid #000000;\r\n                font-size: 12px;\r\n\r\n            }\r\n\r\n            thead {\r\n                tr {\r\n                    background-color: #0094DE;\r\n                    color: white;\r\n\r\n                    th {\r\n                        font-weight: 500 !important;\r\n                    }\r\n                }\r\n            }\r\n\r\n            tbody {\r\n                tr {\r\n                    td {\r\n                        border: 1px solid #000000 !important;\r\n                        font-weight: 400 !important;\r\n                    }\r\n\r\n                }\r\n            }\r\n\r\n        }\r\n    }\r\n}\r\n\r\n\r\n.tableDesign {\r\n    border: 1px solid #98BDED;\r\n\r\n    table {\r\n        width: 100%;\r\n        border-collapse: collapse;\r\n        /* border: 1px solid #AFD1F6 !important; */\r\n\r\n        thead {\r\n            tr {\r\n                color: 'white';\r\n                height: '3.5rem';\r\n                /* border: 1px solid #AFD1F6 !important; */\r\n\r\n                th {\r\n                    border: 1px solid #AFD1F6 !important;\r\n                }\r\n            }\r\n        }\r\n\r\n        tbody {\r\n            tr {\r\n                color: 'white';\r\n                height: '3.5rem';\r\n                border: 1px solid #AFD1F6 !important;\r\n\r\n                td {\r\n                    border: 1px solid #AFD1F6 !important;\r\n                }\r\n            }\r\n        }\r\n\r\n\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
